import { render, staticRenderFns } from "./CandidatesForm.vue?vue&type=template&id=3ee46758&"
import script from "./CandidatesForm.vue?vue&type=script&lang=js&"
export * from "./CandidatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports